<script>
import SignupModal from 'src/components/SignupModal'
import { mapState, mapMutations, mapActions } from 'vuex'
import { emailErrors } from 'src/plugins/validations'
import { notify } from 'src/plugins/notify'
const moment = require('moment')

// import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'Login',
  components: {
    SignupModal
  },
  data () {
    return {
      loginForm: this.$store.state.auth.loginForm,
      banner: null,
      moment: moment
    }
  },
  created () {
    let vm = this

    /**
     * Update this for Holiday Banners! All Logic is implemented.
     * Shows a week before the holiday and 1 day after.
     */           
    let messageText = "ASI will be closed starting July 3rd at 12 PM EST for the July 4th weekend.", // Main Text
        detailText = "", // Sub Text shown below
        holidayDate = "07/04/2025"

    let currentDate = moment.utc(new Date()),
        showDate = moment.utc(new Date(holidayDate)).subtract(7, 'd'),
        endDate = moment.utc(new Date(holidayDate)).add(1, 'd')

    if (
      currentDate.valueOf() >= showDate.toDate().getTime() &&
      currentDate.valueOf() <= endDate.toDate().getTime() && 
      messageText
    ) {
      vm.banner = notify.create({
        message: messageText,
        position: "top",
        type: "info",
        detail: detailText || false,
        timeout: 0
      })
    }
    if (vm.$route.query.logout) {
      notify.create({
        message: "Successfully Logged Out.",
        type: 'positive',
        timeout: 2000
      })
    }
  },
  computed: {
    ...mapState({
      signupModal: s => s.auth.signupModal,
      authenticating: s => s.auth.authenticating
    }),
    emailErrors () { return emailErrors(this.$v.loginForm) }
  },
  methods: {
    ...mapMutations('auth', [
      'toggleSignupModal',
      'updateLoginForm'
    ]),
    ...mapActions('auth', [
      'submitLoginForm'
    ]),
    goToForgotPassword () {
      if (this.banner) this.banner() // Close the notification
      this.$router.push('/forgotpassword')
    },
    goToAttend () {
      let vm = this
      if (vm.banner) vm.banner() // Close the notification
      this.$router.push('/attend')
    },
    fixAffiliates () {
      this.$store.dispatch('fixAffiliates')
    },
    submitLoginFormMethod () {
      let vm = this
      // notify.create({message:"Login available 2/25/2019 at 6:00am EST"})
      this.submitLoginForm({banner: vm.banner})
    }
  }
}

</script>

<template>
  <q-page class="row">
    <div id="login-left" class="col-xl-5 col-lg-6 col-sm-12 col-xs-12 relative-position row items-center">
      <q-card-main class="content-center col-12">
        <form v-on:submit.prevent="">
          <div class="logo text-center"><span>cascades</span></div>
          <q-field class="q-pa-md">
            <q-input autofocus v-model="loginForm.email" type="email" float-label="Email" :before="[{ icon: 'email' }]"/>
          </q-field>
          <q-field class="q-pa-md full-width">
            <q-input v-model="loginForm.password" type="password" float-label="Password" :before="[{ icon: 'lock' }]"/>
          </q-field>
          <q-field class="q-pa-md">
              <div class="float-right">
                <a @click.exact="goToForgotPassword()" class="dotted-underline pointer">Forgot password?</a>
              </div>
            <q-checkbox v-model="loginForm.persistLogin" label="Keep me signed in" />
            </q-field>
          <div class="text-right">
            <q-field class="q-pa-md ">
              <q-btn size="lg" type="submit" :loading="authenticating" label="Login" color="primary" @click="submitLoginFormMethod()"/>
            </q-field>
          </div>
          <!--<q-field class="q-pa-md outline cta-box col-12">
              <span class="text-bold">OR SIGN-UP USING</span>
              <div id="signInMethods" class="float-right">
                <a v-on:click.self.prevent href="#" class="disabled mdi mdi-facebook-box text-primary"></a>
                <a v-on:click.self.prevent href="#" class="disabled mdi mdi-google text-red"></a>
                <a v-on:click.self.prevent href="#" @click="toggleSignupModal()" class="mdi mdi-email text-grey-8"></a>
              </div>
          </q-field>-->
          <q-field class="q-pa-md col-12 cta-box outline">
            <span class="text-bold" style="line-height:25px">ATTEND A CLASS</span>
            <div id="signInMethods" class="float-right">
              <q-btn size="sm" label="Attend" icon="people outline" @click="goToAttend()" color="secondary" outline />
            </div>
          </q-field>
        </form>
      </q-card-main>
      <!-- <q-btn size="sm" label="DON'T PRESS" icon="people outline" @click="fixAffiliates()" color="secondary" outline /> -->
    </div>
    <div id="login-picture" class="col-xl-7 col-lg-6  relative-position mobile-hide"></div>
    <SignupModal :open="signupModal" :toggle="toggleSignupModal"/>
  </q-page>
</template>

<style scoped lang="stylus">
  @import '~variables'
  .logo{
    margin-bottom:80px;
  }
  #login-left{
    border-top:5px solid #4d83ff;
    box-shadow: 0 0 95px #000000ab;
    position: relative;
    z-index: 1;
    padding:0 7%;
    background-image:url('../assets/img/login-left-bg.png');
    background-position:center bottom;
    background-repeat:no-repeat;
    background-color:#fff;
  }
  #login-picture{
    background-size:cover;
    background-image:url('../assets/img/login.jpg');
    background-position:right;
  }
  .q-btn.bg-primary{
    font-size: 15px !important;
    padding: 15px 51px;
    font-weight: 600;
    letter-spacing: 1px;
    @media (max-width: $breakpoint-sm){
      width 100%
    }
  }
  .cta-box{  
    border-radius:2px;
    margin:50px 15px 0;
    padding: 20px 30px;
    &:last-child{
      margin-top 10px
    }
    .text-bold{
      font-size:13px;
    }
  }

  .pointer {
    cursor: pointer
  }
  .outline{
    border:1px solid #ccc; 
  }
  .dotted-underline{
    border-bottom:1px solid #4d83ff;
    text-decoration: none;
    margin-top:4px;
    display:inline-block;
    color:#000;
    font-size:13px;
  }
  #signInMethods{
    font-size:17px;
  }
  #signInMethods a{
    font-size: 30px;
    display: inline-block;
    position: relative;
    top: 5px;
    line-height: 1px;
  }
</style>
